import React, { useEffect } from "react";
//locall
import "./styles/style.css";
import Screens from "./screens";
import { api } from "./utils";
import { AppWrapper } from "./context/state";
import { gsap, CSSPlugin } from "gsap/all";
import "react-toastify/dist/ReactToastify.css";
import "../src/components/toastify/toastify.css";
import { ToastContainer } from "react-toastify";

gsap.registerPlugin(CSSPlugin);

function App() {
  useEffect(() => {
    api.setDefaults();
  }, []);
  return (
    <div className="App">
      <AppWrapper>
        <Screens />
        <ToastContainer
          closeOnClick
          pauseOnHover={false}
          draggable
          rtl
          className="toast-component"
          autoClose={5000}
        />
      </AppWrapper>
    </div>
  );
}

export default App;
